<template lang="pug">
v-layout(align-start='')
    v-flex(xs12)
        v-layout(wrap='' style='display: flex;justify-content: center;')
            v-flex(xs12 style='display: flex;justify-content: center;margin-bottom: 20px;')
                span(style='font-size: 30px;') Perfil
            v-flex(xs12)
                v-layout(wrap='' style='display: flex;justify-content: center;')
                    v-flex(xs10)
                        v-text-field(v-model='form.nombre', label='Nombre de Usuario', dense='', outlined)
                    v-flex(xs10)
                        v-text-field#correoPerfil(v-model='form.correo', label='Correo de Usuario', dense='', outlined)
                    v-flex(xs10)
                        v-text-field.input-group--focused(:append-icon="show3 ? 'visibility' : 'visibility_off'",
                        :type="show3 ? 'text' : 'password'",
                        placeholder='Contraseña'
                        v-model="form.contrasenna"
                        outlined
                        @click:append='show3 = !show3')
                    v-flex(xs10 style='text-align: center;' v-if='editper')
                        span(style='font-size: 26px;') Permisos
                    v-flex(xs10 v-if='editper')
                      v-row(dense)
                        v-col(cols='12' md='12')
                          v-data-table.elevation-1(:headers='headers3', dense, :items='form.Empresa', style='margin-top: 5px;')
                            template(slot='items', slot-scope='props2')
                              | {{ props2.item.nombre }}
                            template(v-slot:item.action='{ item }')
                              v-tooltip(bottom='')
                                template(v-slot:activator='{ on }')
                                  v-icon.mr-2(color='warning', @click='abrirmodal(item)' v-on="on") mdi-pencil
                                | Editar
                      v-dialog(v-model='dialog2' scrollable persistent max-width='800px')
                        v-container(style='background-color:white !important;max-width: 800px;height: 100%;')
                          v-flex(xs12)
                              v-row(dense)
                                v-col(cols='12' md='5')
                                  v-autocomplete(autocomplete="off", v-model='accion', :items='options', label='Accion', dense='', outlined='', multiple='multiple', hint='Seleccione Acción')
                                v-col(cols='12' md='5')
                                  v-autocomplete(autocomplete="off", v-model='ruta', :items='item', label='Ruta', dense='', outlined='', multiple='multiple', hint='Seleccione Categoria')
                                v-col(cols='12' md='2')
                                  v-btn(color='success' dark @click='add(ruta,accion)') Agregar
                              v-row(dense)
                                v-col(cols='12' md='1')
                                v-col(cols='12' md='5')
                                  v-btn(color='error' small dark @click='DeleteAllPermisos()') Eliminar todos los permisos
                                v-col(cols='12' md='1')
                                v-col(cols='12' md='5')
                                  v-btn(color='success' small dark @click='AllPermisos()') Agregar todos los permisos
                              v-row(dense)
                                v-col(cols='12' md='12')
                                  v-data-table.elevation-1(:headers='headers2', dense, :items='listado', style='margin-top: 5px;')
                                    template(slot='items', slot-scope='props2')
                                    template(v-slot:item.action='{ item }')
                                      v-icon(color='error' small='' @click='deleteItem(item)')
                                        | delete
                                    template(v-slot:no-data='')
                                      h3 No se ha asignado permisos
                              v-btn(color='error' small dark @click='close2' class="mr-5") Cancelar
                                v-spacer
                              v-btn(color='success' small dark @click='guardar()')
                                span Guardar
                    v-flex(xs10)
                        v-btn(color='success' small dark @click='save()')
                            span Guardar
</template>

<script>
import Api from '@/services/methods'
export default {
  data: () => ({
    dialog2: false,
    show3: false,
    loading: true,
    headers3: [
      { text: 'Empresas', value: 'nombre', align: 'center' },
      { text: 'Acción', value: 'action', align: 'center' }
    ],
    headers2: [
      { text: 'Ruta', value: 'ruta', align: 'center' },
      { text: 'Acciones', value: 'accion', align: 'center' },
      { text: 'Acción', value: 'action', align: 'center' }
    ],
    item3: ['Ajuste', 'AjustePrecio', 'Almacen', 'AnalisisVencimiento', 'Banco', 'Cliente', 'Compra', 'Concepto', 'Configuracion', 'CuentaPorCobrar', 'CuentaPorCobrarReporte', 'CuentaPorPagar', 'Cuenta', 'Departamento', 'Despacho', 'Empleado', 'Estado', 'EjecucionEstrategica', 'EjecucionPlanificacion', 'Fabricante','FacturaPedido', 'IVA', 'Importacion', 'Kardex', 'Linea', 'LiquidacionDespacho', 'ListadoProducto', 'Marca', 'Municipio', 'NotaCredito', 'NotaDebito', 'NotaEntrega', 'OrdenCompra', 'Pago', 'PagoFactura', 'Parroquia', 'Pedido', 'Perfil', 'Planificacion', 'Portafolio', 'PresentacionProd', 'Producto', 'Proveedor', 'Ruta', 'Serial', 'TipoCliente', 'TipoEmpleado', 'TipoPago', 'TransferirAlmacen', 'UnidadVenta', 'Vehiculo', 'Vendedor', 'Venta', 'Zona', 'OrdenesDeCotizacion', 'Soporte'],
    item2: ['Ajuste', 'AjustePrecio', 'Almacen', 'AnalisisVencimiento', 'Banco', 'Cliente', 'Compra', 'Concepto', 'Configuracion', 'CuentaPorCobrar', 'CuentaPorCobrarReporte', 'CuentaPorPagar', 'Cuenta', 'Departamento', 'Despacho', 'Empleado', 'Estado', 'EjecucionEstrategica', 'EjecucionPlanificacion', 'Fabricante','FacturaPedido', 'IVA', 'Kardex', 'Linea', 'LiquidacionDespacho', 'ListadoProducto', 'Marca', 'Municipio', 'NotaCredito', 'NotaDebito', 'NotaEntrega', 'OrdenCompra', 'Pago', 'PagoFactura', 'Parroquia', 'Pedido', 'Perfil', 'Planificacion', 'Portafolio', 'PresentacionProd', 'Producto', 'Proveedor', 'Ruta', 'Serial', 'TipoCliente', 'TipoEmpleado', 'TipoPago', 'TransferirAlmacen', 'UnidadVenta', 'Vehiculo', 'Vendedor', 'Venta', 'Zona', 'OrdenesDeCotizacion', 'Soporte'],
    item: ['Ajuste', 'AjustePrecio', 'Almacen', 'AnalisisVencimiento', 'Banco', 'Cliente', 'Compra', 'Concepto', 'Configuracion', 'CuentaPorCobrar', 'CuentaPorCobrarReporte', 'CuentaPorPagar', 'Cuenta', 'Departamento', 'Despacho', 'Empleado', 'Estado', 'EjecucionEstrategica', 'EjecucionPlanificacion', 'Fabricante','FacturaPedido', 'IVA', 'Kardex', 'Linea', 'LiquidacionDespacho', 'ListadoProducto', 'Marca', 'Municipio', 'NotaCredito', 'NotaDebito', 'NotaEntrega', 'OrdenCompra', 'Pago', 'PagoFactura', 'Parroquia', 'Pedido', 'Perfil', 'Planificacion', 'Portafolio', 'PresentacionProd', 'Producto', 'Proveedor', 'Ruta', 'Serial', 'TipoCliente', 'TipoEmpleado', 'TipoPago', 'TransferirAlmacen', 'UnidadVenta', 'Vehiculo', 'Vendedor', 'Venta', 'Zona', 'OrdenesDeCotizacion', 'Soporte'],
        
    listado: [],
    itemres: [],
    ruta: '',
    accion: '',
    editper: false,
    options: ['Ver', 'Crear', 'Modificar', 'Eliminar'],
    editedIndex: -1,
    empresaselec: {},
    id: '',
    form: {
      _id: '',
      nombre: '',
      correo: '',
      contrasenna: '',
      Empresa: []
    },
    defaultItem: {
      _id: '',
      nombre: '',
      correo: '',
      contrasenna: '',
      Empresa: []
    }
  }),
  created () {
    this.id = this.$store.state.usuario._id
    this.initialize()
  },
  methods: {
    initialize () {
      this.editper = false
      Api.get('/usuario/' + this.id).then((response) => {
        if (!response.data.master) {
          this.editper = true
        }
        Object.keys(this.form).map(key => {
          if (response.data[key]) this.form[key] = response.data[key]
        })
      })
    },
    guardar () {
      for (let i = 0; i < this.form.Empresa.length; i++) {
        if (this.empresaselec.idEmpresa === this.form.Empresa[i].idEmpresa) {
          this.form.Empresa[i].permisos = []
          for (let j = 0; j < this.listado.length; j++) {
            this.form.Empresa[i].permisos.push(this.listado[j])
          }
        }
      }
      this.dialog2 = false
    },
    close2 () {
      this.dialog2 = false
      this.listado = []
      this.item = []
      for (let i = 0; i < this.itemres.length; i++) {
        this.item.push(this.itemres[i])
      }
    },
    abrirmodal (data) {
      this.empresaselec = data
      this.listado = []
      for (let i = 0; i < data.permisos.length; i++) {
        this.listado.push(data.permisos[i])
      }
      if (this.empresaselec.nombre.includes('says') || this.empresaselec.nombre.includes('Says') || this.empresaselec.nombre.includes('SAYS')) {
        this.item = ['Ajuste', 'AjustePrecio', 'Almacen', 'AnalisisVencimiento', 'Banco', 'Cliente', 'Compra', 'Concepto', 'Configuracion', 'CuentaPorCobrar', 'CuentaPorCobrarReporte', 'CuentaPorPagar', 'Cuenta', 'Departamento', 'Despacho', 'Empleado', 'Estado', 'EjecucionEstrategica', 'EjecucionPlanificacion', 'Fabricante','FacturaPedido', 'IVA', 'Importacion', 'Kardex', 'Linea', 'LiquidacionDespacho', 'ListadoProducto', 'Marca', 'Municipio', 'NotaCredito', 'NotaDebito', 'NotaEntrega', 'OrdenCompra', 'Pago', 'PagoFactura', 'Parroquia', 'Pedido', 'Perfil', 'Planificacion', 'Portafolio', 'PresentacionProd', 'Producto', 'Proveedor', 'Ruta', 'Serial', 'TipoCliente', 'TipoEmpleado', 'TipoPago', 'TransferirAlmacen', 'UnidadVenta', 'Vehiculo', 'Vendedor', 'Venta', 'Zona', 'OrdenesDeCotizacion', 'Soporte']
      } else {
        this.item = ['Ajuste', 'AjustePrecio', 'Almacen', 'AnalisisVencimiento', 'Banco', 'Cliente', 'Compra', 'Concepto', 'Configuracion', 'CuentaPorCobrar', 'CuentaPorCobrarReporte', 'CuentaPorPagar', 'Cuenta', 'Departamento', 'Despacho', 'Empleado', 'Estado', 'EjecucionEstrategica', 'EjecucionPlanificacion', 'Fabricante','FacturaPedido', 'IVA', 'Kardex', 'Linea', 'LiquidacionDespacho', 'ListadoProducto', 'Marca', 'Municipio', 'NotaCredito', 'NotaDebito', 'NotaEntrega', 'OrdenCompra', 'Pago', 'PagoFactura', 'Parroquia', 'Pedido', 'Perfil', 'Planificacion', 'Portafolio', 'PresentacionProd', 'Producto', 'Proveedor', 'Ruta', 'Serial', 'TipoCliente', 'TipoEmpleado', 'TipoPago', 'TransferirAlmacen', 'UnidadVenta', 'Vehiculo', 'Vendedor', 'Venta', 'Zona', 'OrdenesDeCotizacion', 'Soporte']
      }
      this.itemres = []
      for (let i = 0; i < this.form.Empresa.length; i++) {
        if (data.idEmpresa === this.form.Empresa[i].idEmpresa) {
          for (let j = 0; j < this.form.Empresa[i].permisos.length; j++) {
            for (let e = 0; e < this.item.length; e++) {
              if (this.form.Empresa[i].permisos[j].ruta === this.item[e]) {
                this.item.splice(e, 1)
                e = 0
              }
            }
          }
        }
      }
      for (let i = 0; i < this.item.length; i++) {
        this.itemres.push(this.item[i])
      }
      this.dialog2 = true
    },
    deleteItem (item) {
      this.$swal
        .fire({
          title: '¿Estás seguro?',
          text: 'No podrás revertir esta operación!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, Eliminar!'
        })
        .then(result => {
          if (result.value) {
            for (let i = 0; i < this.listado.length; i++) {
              if (this.listado[i].ruta === item.ruta) {
                this.listado.splice(i, 1)
                this.item.push(item.ruta)
              }
            }
            for (let i = 0; i < this.empresaselec.permisos.length; i++) {
              if (this.empresaselec.permisos[i].ruta === item.ruta) {
                this.empresaselec.permisos.splice(i, 1)
              }
            }
          }
        })
    },
    AllPermisos () {
      this.ruta = ''
      this.accion = ''
      this.listado = []
      if (this.empresaselec.nombre.includes('says') || this.empresaselec.nombre.includes('Says') || this.empresaselec.nombre.includes('SAYS')) {
        for (let i = 0; i < this.item3.length; i++) {
          this.listado.push({
            ruta: this.item3[i],
            accion: 'Ver Crear Modificar Eliminar'
          })
        }
        this.$swal('Felicidades.!', 'Permisos Agregados con Exito.', 'success')
        this.item = []
      } else {
        for (let i = 0; i < this.item2.length; i++) {
          this.listado.push({
            ruta: this.item2[i],
            accion: 'Ver Crear Modificar Eliminar'
          })
        }
        this.$swal('Felicidades.!', 'Permisos Agregados con Exito.', 'success')
        this.item = []
      }
    },
    DeleteAllPermisos () {
      this.ruta = ''
      this.accion = ''
      this.listado = []
      this.item = []
      this.empresaselec.permisos = []
      if (this.empresaselec.nombre.includes('says') || this.empresaselec.nombre.includes('Says') || this.empresaselec.nombre.includes('SAYS')) {
        for (let i = 0; i < this.item3.length; i++) {
          this.item.push(this.item3[i])
        }
        this.$swal('Felicidades.!', 'Permisos Eliminados con Exito.', 'success')
        
      } else {
        for (let i = 0; i < this.item2.length; i++) {
          this.item.push(this.item2[i])
        }
        this.$swal('Felicidades.!', 'Permisos Eliminados con Exito.', 'success')
      }
    },
    add (ruta, accion) {
      let bols = false
      let view = false
      if (ruta && accion) {
        for (let j = 0; j < accion.length; j++) {
          if (accion[j] === 'Ver') {
            view = true
          }
        }
        if (view === true) {
          if (this.empresaselec.permisos.length > 0) {
            for (let i = 0; i < this.empresaselec.permisos.length; i++) {
              for (let j = 0; j < ruta.length; j++) {
                if (this.empresaselec.permisos[i].ruta === ruta[j]) {
                  bols = true
                }
              }
            }
          }
          if (bols === false) {
            let stg = ''
            for (let e = 0; e < accion.length; e++) {
              stg += accion[e] + ' '
            }
            for (let i = 0; i < ruta.length; i++) {
              this.listado.push({ ruta: ruta[i], accion: stg })
              for (let j = 0; j < this.item.length; j++) {
                if (ruta[i] === this.item[j]) {
                  this.item.splice(j, 1)
                }
              }
            }
            this.$swal(
              'Felicidades.!',
              'Permiso Agregado con Exito.',
              'success'
            )
            this.ruta = ''
            this.accion = ''
          } else {
            this.$swal(
              'Oops...',
              'Ya posee en la lista esta misma ruta, eliminela y vuelva a añadir si desea modificarla.',
              'error'
            )
          }
        } else {
          this.$swal(
            'Oops...',
            'Para agregar esta o estas acciones a la lista es necesario incluir la acción (VER) en la misma.',
            'error'
          )
        }
      } else {
        this.$swal(
          'Oops...',
          'Debe ingresar ambos campos( ruta y accion ) para poder agregarlo a la lista.',
          'error'
        )
      }
    },
    save () {
      if (this.form.nombre && this.form.correo && this.form.contrasenna) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        Api.put('usuario/perfil', this.form)
          .then(response => {
            if (this.form._id === this.$store.state.usuario._id) {
              this.$store.dispatch('usuarioPer', this.form)
            }
            this.$swal({
              icon: 'success',
              title: 'Inclusion exitosa',
              text: 'Todos los datos han sido guardados'
            })
            this.initialize()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message);
            }
          })
      } else {
        this.$swal({
          icon: 'error',
          title: 'Error al guardar',
          text: 'Por favor, verifique los datos e intente de nuevo'
        })
      }
    }
  }
}
</script>
